import Vue from 'vue'
import Vuex from 'vuex'
import options from './modules/options'
import {getDictList} from 'api/query'
Vue.use(Vuex)
const state = {
  sideBarActive: '',
  language: 'chinese',
  avatarImgPath: '',
  token: '',
  userInfo: {},
  controlAuth:JSON.parse(sessionStorage.controlAuth || "[]"),
  formData:JSON.parse(sessionStorage.formData || "{}"),
  controlInfo: JSON.parse(sessionStorage.controlInfo || JSON.stringify({
    controllerPsn: 'C980098EABBD233A', // psn
    controllerNo: '2', // 控制器号
    manualStat: '0', // 手动状态
    autoStat: '0' // 自动状态
  })),
  sysSetting: JSON.parse(sessionStorage.sysSetting || "{}"),
  typeList:[], // 类型
  statList:[], // 事件
  relateData:[], // 撤销事件
  monicentorList: JSON.parse(sessionStorage.monicentorList || "[]"),
  startAndStop: sessionStorage.startAndStop === undefined ? "" : sessionStorage.startAndStop , // 回路状态浏览 :statusBrowsing ; 探测器模拟曲线: simulationCurve  ; 现场部件数据查询: dataQuery
  // startAndStop: sessionStorage.startAndStop === "false" ? false : true,
  responseErrFlag: sessionStorage.responseErrFlag === 'true' || false,
  currentAnalogLine: {},
  currentLoopStatus: {},
  currentComponentData: {},
  debugStatus: Number(sessionStorage.debugStatus) || 1, // 调试状态: 1 开始调试 ; 2 : 等待中;  3 : 调试成功跳转页面
  tidType: sessionStorage.tidType , // TidType: timeStamp (时间戳处理)| secondes 直接赋值给倒计时 debugSeconds
  debugSeconds: Number(sessionStorage.debugSeconds) || 0,
  debugFlag: sessionStorage.debugFlag === "true" || false, // 开始调试 : false 调试成功 true 调试页面
  faultReceive: sessionStorage.faultReceive === "true" || false,
  debugErrorData: JSON.parse(sessionStorage.DebugData || "{}"),
  debugKey: sessionStorage.debugKey || "",
  fireCount: "0000",
  faultCount: "0000",
  regularCount: "0000",
  shieldCount: "0000",
  feedbackCount: "0000",
  // 基本标准项(数据字典)列表
  network_modelOptions: [],
  network_modelTypeOptions: [
    // {code:'1', name:"2121"},
    // {code:'2', name:"ccc"}
  ],
  controller_modeOptions: [],
  deviceTypeOptions: [],
  operation: [],
  statOptions: [],
  statTypeOptions: [],
  controllerTypeOptions: [],
  boardTypeOptions: [],
  collapsed:Boolean(sessionStorage.collapsed) || false,
  muteFlag: sessionStorage.muteFlag === 'true' ? true : false,
  currentAlarmFlag: sessionStorage.currentAlarmFlag === 'true' ? true : false,
}
const mutations = {
  setMuteFlag(state, value){
    state.muteFlag = value;
  },
  setDebugKey(state, value){
    state.debugKey = value;
  },
  setfaultReceive(state, value){
    state.faultReceive = value;
  },
  setCollapsed(state, value){
    state.collapsed = value;
  },
  setFormData(state, value){
    state.formData = value;
  },
  setSideBarActive(state, value){
    state.sideBarActive = value;
  },
  setFireCount(state, value){
    state.fireCount = value;
  },
  setLanguage(state, value){
    state.language = value;
  },
  setFaultCount(state, value){
    state.faultCount = value;
  },
  setRegularCount(state, value){
    state.regularCount = value;
  },
  setShieldCount(state, value){
    state.shieldCount = value;
  },
  setFeedbackCount(state, value){
    state.feedbackCount = value;
  },
  setDebugData(state, value){
    state.debugErrorData = value;
  },
  setrRlateData(state, value){
    state.relateData = value
  },
  setSysSetting(state, value){
    state.sysSetting = value
  },
  setControlInfo(state, value){
    state.controlInfo = value
  },
  changeTidType(state, value){
    state.tidType = value
  },
  changeDebugSeconds(state, value){
    state.debugSeconds = value
  },
  changeDebugStatus(state, value){
    state.debugStatus = value
  },
  changeDebugFlag(state, flag){
    state.debugFlag = flag;
  },
  setCurrentAnalogLine(state, value){
    state.currentAnalogLine = value
  },
  setCurrentLoopStatus(state, value){
    state.currentLoopStatus = value
  },
  setCurrentComponentData(state, value){
    state.currentComponentData = value
  },
  setTypeList(state, value){
    state.typeList = value
  },
  changeStartAndStop(state, value) {
    state.startAndStop = value;
  },
  changeResponse(state, value){
    state.responseErrFlag = value;
  },
  setStatList(state, value){
    state.statList = value
  },
  percentageIncrement(state) {
    state.percentage += 1
  },
  setToken(state, value) {
    state.token = value
  },
  // 设置用户的基本信息
  setUserInfo(state, value) {
    state.userInfo = value
  },
  setControlAuth(state, value){
    state.controlAuth = value
  },
  initNetworkModel(state) {
    getDictList({type: 'network_model'}).then(res => {
      state.network_modelOptions = res.data
    })
  },
  initNetworkModelType(state) {
    getDictList({type: 'network_model_type'}).then(res => {
      state.network_modelTypeOptions = res.data
    })
  },
  initControllerMode(state) {
    getDictList({type: 'controller_mode'}).then(res => {
      state.controller_modeOptions = res.data
    })
  },
  initDeviceTypeOptions(state) {
    getDictList({type: 'device_type'}).then(res => {
      state.deviceTypeOptions = res.data
    })
  },
  initOperation(state) {
    getDictList({type: 'operation'}).then(res => {
      state.operation = res.data
    })
  },
  initStatOptions(state) {
    getDictList({type: 'stat'}).then(res => {
      state.statOptions = res.data
    })
  },
  initStatTypeOptions(state, value) {
    getDictList({type: 'stat_type'}).then(res => {
      state.statTypeOptions = res.data
    })
  },
  initControllerTypeOptions(state, value) {
    getDictList({type: 'controller_type'}).then(res => {
      state.controllerTypeOptions = res.data
    })
  },
  initBoardTypeOptions(state, value) {
    getDictList({type: 'board_type'}).then(res => {
      state.boardTypeOptions = res.data
    })
  }
}
const getters = {
  uid: (state) => state.userInfo ? state.userInfo._id : '',
  debugErrorData: (state) => state.debugErrorData,
  sideBarActive: (state) => state.sideBarActive
}
const actions = {
  init(context) {
    context.commit('initNetworkModel');
    context.commit('initControllerMode');
    context.commit('initDeviceTypeOptions');
    context.commit('initOperation');
    context.commit('initStatOptions');
    context.commit('initStatTypeOptions');
    context.commit('initNetworkModelType');
    context.commit('initControllerTypeOptions');
    context.commit('initBoardTypeOptions');
  }
}
export default new Vuex.Store({
  modules: { options },
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
})
